import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import StickyTooltip from './StickyTooltip';
import styles from './TooltipHint.css';

const cx = classNames.bind(styles);

class TooltipHint extends React.Component {
  render() {
    const { tooltip, placement } = this.props;

    if (!tooltip) {
      return this._renderGlyph();
    }

    return (
      <StickyTooltip
        tooltipClassName={styles['tooltip-hint']}
        component={tooltip}
        placement={placement}
        delay={200}
      >
        {this._renderGlyph()}
      </StickyTooltip>
    );
  }

  _renderGlyph = () => {
    const { color, className, glyph, noWrapper } = this.props;

    if (noWrapper) {
      return glyph;
    }

    const fullClassName = cx('hint-icon', className);
    const style = {
      backgroundColor: color,
    };

    return (
      <span className={fullClassName} style={style}>
        {glyph}
      </span>
    );
  };
}

TooltipHint.propTypes = {
  glyph: PropTypes.node,
  noWrapper: PropTypes.bool,
  className: PropTypes.string,
  tooltip: PropTypes.node,
  placement: PropTypes.string,
};

TooltipHint.defaultProps = {
  glyph: '?',
  placement: 'top',
  noWrapper: false,
};

export default TooltipHint;
